import { useEffect, useReducer } from 'react';
import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import { baseApi } from 'src/services';
import { useAppDispatch, useAppSelector } from 'src/store';
import moment from 'moment';

const RefreshBtn = ({ disabled = false }: { disabled?: boolean }) => {
  const { lastUpdate } = useAppSelector((s) => s.analyticSlices);
  const dispatch = useAppDispatch();

  // Re-renders every minute so the relative "last update" time stays current.
  const [, rerender] = useReducer((tick: number) => tick + 1, 0);

  useEffect(() => {
    const interval = setInterval(() => {
      rerender();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    dispatch(baseApi.util.invalidateTags(['CoCustomerAnalyticsAggregated']));
  };

  return (
    <Button
      variant="ghost"
      className={clsx(disabled && 'pointer-events-none opacity-50', 'flex gap-2 refresh-btn')}
      onClick={handleRefresh}
      disabled={disabled}
    >
      <p className="font-medium text-xs opacity-50">Last refresh {moment(lastUpdate).fromNow()}</p>
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M14.7273 3.5L11.4545 7H13.9091C13.9091 8.39239 13.3919 9.72775 12.4713 10.7123C11.5506 11.6969 10.302 12.25 9 12.25C8.18182 12.25 7.38818 12.0312 6.70909 11.6375L5.51455 12.915C6.55616 13.624 7.76532 14.0004 9 14C10.736 14 12.4008 13.2625 13.6283 11.9497C14.8558 10.637 15.5455 8.85652 15.5455 7H18M4.09091 7C4.09091 5.60761 4.60812 4.27226 5.52875 3.28769C6.44938 2.30312 7.69803 1.75 9 1.75C9.81818 1.75 10.6118 1.96875 11.2909 2.3625L12.4855 1.085C11.4438 0.376034 10.2347 -0.000367163 9 2.68751e-07C7.26404 2.68751e-07 5.59918 0.737498 4.37166 2.05025C3.14415 3.36301 2.45455 5.14348 2.45455 7H0L3.27273 10.5L6.54545 7"
          fill="#05050D"
        />
      </svg>
    </Button>
  );
};

export default RefreshBtn;
